import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CompanyMeetingResponseDto, CompanyMeetingUpsertRequest } from '../../models/api/companyMeetingDto';
import { YearlyResource } from '../../models/api/yearlyResource';

@Injectable({
  providedIn: 'root'
})
export class CompanyMeetingService {
  private apiUrl = `${environment.apiUrl}/companies`;

  constructor(private http: HttpClient) {}

  getMeeting(companyId: string, year?: number): Observable<YearlyResource<CompanyMeetingResponseDto>> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.get<YearlyResource<CompanyMeetingResponseDto>>(
      `${this.apiUrl}/${companyId}/meetings`,
      { params }
    );
  }

  updateMeeting(companyId: string, request: CompanyMeetingUpsertRequest): Observable<YearlyResource<CompanyMeetingResponseDto>> {
    return this.http.put<YearlyResource<CompanyMeetingResponseDto>>(`${this.apiUrl}/${companyId}/meetings`, request);
  }
}
